import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { IClubMember } from '@soposopo/sopo-models';
import { BrockenImageSize, GameSettingsService, ImageType } from 'src/app/core/firebase/gameSettings.service';
import { SopoDialogRef, SOPO_DIALOG_DATA } from '../../interfaces/dialog';
import { ChatUserInfoDispatcher } from 'src/app/core/state/chatUserInfo/chatUserInfo.dispatcher';
import { AuthStoreDispatcher } from 'src/app/core/state/auth/auth.dispatcher';
import { IChatUserInfoData } from 'src/app/core/state/chatUserInfo/chatUserInfo.state';
import { Subscription } from 'rxjs';
import { GameThemeSettingsDispatcher } from 'src/app/core/state/gameThemeSettings/gameThemeSettings.dispatcher';

export interface SopoNumberInputData {
    header?: string;
    body?: string;
    okText?: string;
    cancelText?: string;
    placeholder?: string;
    clubBalance?: number,
    clubName?: string;
    senderID?: string,
    receiverIDs?: string[],
    isAdmin?: boolean,
    selectedMembersBalance?: any,
    senderIDs?: string[],
    receiverID?: string,
    inGame?: boolean,
    maximumAmount?: number,
}

@Component({
    selector: 'app-sopo-number-input',
    templateUrl: './sopo-number-input.component.html',
    styleUrls: ['./sopo-number-input.component.scss'],
    standalone: false
})
export class SopoNumberInputComponent implements OnInit, AfterViewInit, OnDestroy {
    input: number;
    @ViewChild('numberInput', { static: true }) number_input: ElementRef;
    header: string;
    body: string;
    cancelText: string;
    okText: string;
    placeholder: string;
    clubBalance: number;
    clubName: string;
    senderID: string;
    receiverID: string;
    receiverIDs: string[] = [];
    receiverName: string;
    balanceLable: string;
    checkBoxMsg: string;
    isChecked = false;
    senderImg: string;
    receiverImg: string;
    sendoutData: {[id: string]: IChatUserInfoData} = {};
    userInfoSubscriptions: {id: string, subscription: Subscription}[] = [];
    private showAvatar = true;
    private showAvatarSubscription: Subscription;
    SERVICE_TAX = 0.05;
    isSendOut = false;
    serviceTaxChips = 0;
    hasError = false;
    errorMessage = '';
    tax: number;
    isAdmin = false;
    membersBalance: IClubMember[];
    senderIDs: string[];
    members: string[];
    disableOkTextButton = false;
    diamondsEnabled = false;
    inGame = false;
    myId = '';
    maximumAmount: number;

    constructor(
        private sopoDialogRef: SopoDialogRef,
        private authDispatcher: AuthStoreDispatcher,
        @Inject(SOPO_DIALOG_DATA) public data: SopoNumberInputData,
        private chatUserInfoDispatcher: ChatUserInfoDispatcher,
        private gameThemeSettingsDispatcher: GameThemeSettingsDispatcher,
    ) {
        this.header = data.header;
        this.body = data.body;
        this.cancelText = data.cancelText;
        this.okText = data.okText;
        this.placeholder = data.placeholder;
        this.clubBalance = data.clubBalance;
        this.clubName = data.clubName;
        this.senderID = data.senderID;
        this.receiverID = data.receiverID;
        this.receiverIDs = data.receiverIDs;
        this.isSendOut = false;
        this.hasError = false;
        this.errorMessage = '';
        this.isAdmin = data.isAdmin;
        this.membersBalance = data.selectedMembersBalance;
        this.senderIDs = data.senderIDs;
        this.inGame = data.inGame;
        this.clubName = data.clubName;
        this.maximumAmount = data.maximumAmount;
    }

    ngOnInit() {
        if (this.inGame) {
            this.showAvatarSubscription = this.gameThemeSettingsDispatcher.getThemeOptions('showAvatars').subscribe(showAvatars => {
                this.showAvatar = showAvatars;
            });
        }
        
        if (this.okText === 'Claim Back') {
            if (!this.isAdmin) this.createMyAvatarSubscription();
            this.balanceLable = 'Member Balance';
            this.receiverImg = this.receiverID;
            this.checkBoxMsg = 'Reclaim full member balance';
            this.isSendOut = false;
            this.errorMessage = 'No member is eligible for reclaim';
            this.senderIDs.forEach((id) => {
                this.createUserInfoSubscription(id);
            });
        }
        if (this.okText === 'Send Out') {
            if (this.isAdmin) {
                this.balanceLable = 'Club Balance';
                this.checkBoxMsg = 'Send full club balance';
            } else {
                this.balanceLable = 'Agent Balance';
                this.checkBoxMsg = 'Send full agent balance';
                this.createMyAvatarSubscription();
            }
            this.senderImg = this.senderID;
            this.receiverIDs.forEach((id) => {
                this.createUserInfoSubscription(id);
            });
        }
    }

    async createMyAvatarSubscription(): Promise<void> {
        this.myId = await this.authDispatcher.getMyID();
        this.createUserInfoSubscription(this.myId);
    }

    createUserInfoSubscription(userId: string): void {
        this.chatUserInfoDispatcher.requestForChatUserInfos([userId]);
        const userInfoSubscription = this.chatUserInfoDispatcher.getChatUserInfoObservable(userId).subscribe(chatUserInfo => {
            this.sendoutData[userId] = chatUserInfo;
        });
        this.userInfoSubscriptions.push({
            id: userId,
            subscription: userInfoSubscription
        });
    }

    onImageError(event: any, size?: BrockenImageSize, type?: ImageType) {
        event.target.src = GameSettingsService.getSopoBrokenImageUrl(size, type);
    }
    
    getAvatarUrl(userId: string): string {
        if (!this.showAvatar && this.inGame) return 'assets/icon/thumbnail.png';
        if (this.sendoutData[userId].useNftAsAvatar) {
            if(this.sendoutData[userId].usingCroppedImage) {
                if (this.sendoutData[userId].croppedImageUrl) return this.sendoutData[userId].croppedImageUrl;
                return 'assets/img/cropped_nft_loader.gif';
            }
            return this.sendoutData[userId].nftUrl;
        } else return GameSettingsService.getAvatarUrl(this.sendoutData[userId].photoUrl);
    }

    ngAfterViewInit() {
        setTimeout(() => {
            this.number_input.nativeElement.focus();
        }, 500);
    }

    allChips(e) {
        e.checked = !this.isChecked;
        this.isChecked = !this.isChecked;
        if (this.isSendOut && this.isChecked) {
            this.input = Number(this.clubBalance);
            this.validateServiceTax(this.input);
        } else {
            this.hasError = false;
            this.errorMessage = '';
            this.input = 0;
            this.validateServiceTax(this.input);
        }
    }

    confirm() {
        if(this.hasError || this.disableOkTextButton) return;
        switch (this.okText) {
            case 'Send Out':
                this.sopoDialogRef.close({ value: this.input, tax: this.tax });
                break;
            case 'Claim Back':
                this.disableOkTextButton = true;
                this.sopoDialogRef.close({ value: this.input, members: this.members });
                break;
          }
    }

    cancel() {
        this.sopoDialogRef.close({ value: undefined });
    }

    validateServiceTax(chips): void {
        this.tax = this.chipsRoundUp(chips * this.SERVICE_TAX * this.receiverIDs.length);
        this.serviceTaxChips = this.tax + this.input * this.receiverIDs.length;
        if (this.serviceTaxChips > Number(this.clubBalance) && this.diamondsEnabled) {
            this.hasError = true;
            if (this.isAdmin) {
                this.errorMessage = "Can't send more the club balance!";
            } else {
                this.errorMessage = "Can't send more the agent balance!";
            }
        } else {
            this.hasError = false;
            this.errorMessage = '';
        }
    }

    validateMemberBalance(chips: number) {
        this.members = this.senderIDs.filter(memberId => {
            const member = this.membersBalance.find(member => member.id === memberId);
            return member && this.chipsRoundUp(member.balance) >= chips;
        });
        this.hasError = this.members.length < 1;
    }

    onModelChange(input) {
        if(this.maximumAmount && this.maximumAmount < input) {
            this.number_input.nativeElement.value = this.maximumAmount;
            input = this.maximumAmount;
            this.input = this.maximumAmount;
        }
        if (this.okText === 'Send Out') this.validateServiceTax(input)
        else this.validateMemberBalance(input)
    }

    getMemberBalance(id: string): number {
        const member = this.membersBalance.find(member => member.id === id);
        if (member) return member.balance;
        return 0;
    }

    chipsRoundUp(chips) {
        return parseFloat(chips.toFixed(2));
    }

    ngOnDestroy(): void {
        if (this.showAvatarSubscription) this.showAvatarSubscription.unsubscribe();
        if (this.userInfoSubscriptions.length) 
        this.userInfoSubscriptions.forEach(infoSubscription => {
            infoSubscription.subscription.unsubscribe();
            this.chatUserInfoDispatcher.clearRequestForChatUserInfos([infoSubscription.id]);
        });
    }
}
